import React from "react";
import styles from "../../static/css/pages.module.css";
import Title from "../../components/title/title";
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import PageInfo from './list_info';
import PageReferences from "./list_references";
import ServerWaiting from "../server/loading";
import {connect} from "react-redux";
import * as consts from "../../store/constants/userData";
import {getInfoAction} from "../../store/actions/getInfoAction";
import ServerRegister from "../server/register";
import ieSvg from "../../components/icons/ieSvg";

class PanelInfo extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      result: {
        status: '',
        errorMessage: ''
      },
      isReferences: false
    }
  }

  componentDidMount() {
    document.title = "Информация для вас | Самозанятые";
    ieSvg();
    if (this.props.data.items) return;
    this.props.fetchData(process.env.REACT_APP_GATE + "partner/settings", this, consts.PARTNER_SETTINGS);
  }

  render() {
    if (this.props.data.items) {
      switch (this.props.data.items.result.status) {
        case "ERROR":
        case "TIMEOUT":
          return (<div className={styles.content}>
            <div>
              <div className="l-grid_pt-8 mobile_l-grid">
                <div className="l-grid__item_1"/>
                <div className="l-grid__item_6 mobile_l-grid__item_10 l-position_relative">
                  <Title icon="icon_menu-info" title="Информация для вас"/>
                  <PageInfo/>
                </div>
              </div>
            </div>
          </div>);
        case "SUCCESS":
          return <TabReferenceInner data={this.props.data.items}/>;
        default:
          return <ServerWaiting pageTitle="Информация для вас" waiting="Загружаем информацию..."
                                pageIcon="icon_menu-operations"/>;
      }
    } else {
      return <ServerWaiting pageTitle="Информация для вас" waiting="Загружаем информацию..."
                            pageIcon="icon_menu-operations"/>
    }
  }
}

class TabReferenceInner extends React.Component {
  componentDidMount() {
    ieSvg();
  }
  render() {
    const isReferenceHide = !this.props.data.data.length || (this.props.data.data[0].value === 'false' && this.props.data.data[1].value === 'false');
    return (
      <div className={styles.content}>
        <div className="l-grid_pt-8 mobile_l-grid">
          <div className="l-grid__item_1"/>
          <div className="l-grid__item_6 mobile_l-grid__item_10 l-position_relative">
            <Title icon="icon_menu-info" title="Информация для вас"/>
            <Tabs>
              <TabList>
                <Tab>Информация</Tab>
                { isReferenceHide ?
                  null
                  :
                  <Tab>Справки</Tab>
                }
              </TabList>
              <TabPanel>
                <PageInfo/>
              </TabPanel>
              <TabPanel>
                {this.props.data.result.errorCode === 'TAXPAYER_UNBOUND' || this.props.data.result.errorCode === 'TAXPAYER_UNREGISTERED' ?
                  <ServerRegister errorMessage={this.props.data.result.errorMessage}/>
                  :
                  <PageReferences data={this.props.data.data}/>
                }
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({data: state.partnerSettings});

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, parent, types) => dispatch(getInfoAction(url, parent, types))};
};

export default connect(mapStateToProps, mapDispatchToProps)(PanelInfo);